(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React from 'react';
import styled from 'styled-components';
import { SPACE } from "../../constants/style";
var StyledDiv = styled('div').withConfig({
  displayName: "FieldError__StyledDiv",
  componentId: "sc-jf13hk-0"
})(["font-family:", ";color:", ";margin-top:", ";"], function (props) {
  return props.theme.styles.fonts.secondary;
}, function (props) {
  return props.theme.styles.colors.errorColor;
}, SPACE.sm);

var FieldError = function FieldError(props) {
  var children = props.children;
  return React.createElement(StyledDiv, null, children);
};

var _default = FieldError;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(StyledDiv, "StyledDiv", "/home/vsts/work/1/s/src/components/forms/FieldError.js");
  reactHotLoader.register(FieldError, "FieldError", "/home/vsts/work/1/s/src/components/forms/FieldError.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/forms/FieldError.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();